import React, { ForwardRefExoticComponent, SVGProps } from 'react'

import { Star } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { RatingElementQuestion } from 'modules/forms/components/QuestionComponent/RatingElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

/**
 * RatingElement class for rating input elements.
 * Extends the base Element class.
 */
export class RatingElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): RatingElement {
    const el = new RatingElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked, //locked element are always mandatory
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.rating')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'rating'
  }
  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Star
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <RatingElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <RatingElementQuestion element={this} onChange={onChange} />
  }

  /**
   * Get the minimum value allowed
   */
  get optionalComment(): string | undefined {
    return this.params.optionalComment ?? undefined
  }
}
